// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
// import axios from "axios";
// import NavigationBar from "../../Components/NavigationBar";

// export default function SendEmailApplicant() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

//   const { applicationId, awardType, name, email } = location.state || {};

//   console.log("Received data:", { applicationId, awardType, name, email });

//   const [recipientName, setRecipientName] = useState("");
//   const [recipientEmail, setRecipientEmail] = useState("");
//   const [emailSubject, setEmailSubject] = useState("");
//   const [ccEmails, setCcEmails] = useState("");
//   const [emailBody, setEmailBody] = useState("");

//   // Set default subject and body when component loads
//   useEffect(() => {
//     if (awardType) {
//       console.log("Setting email body with award type:", awardType);
//       setEmailSubject(`Verification and Approval of – ${awardType}`);

//       // Default email body when page loads
//       const defaultBody = `
// Dear ${name || "[Recipient Name]"},

// Thank you for submitting your application for Article Processing Charge (APC) reimbursement. We are pleased to confirm that your manuscript meets the eligibility criteria for APC reimbursement.

// Reimbursement Details:
// o	International Journals: If your manuscript is submitted to an international journal, you are eligible for reimbursement of up to US$1,500.
// o	Ceylon Journal of Science: If your manuscript is submitted to the Ceylon Journal of Science, you are eligible for reimbursement of up to LKR 10,000.

// Next Steps:
// Proceed with Payment: Please make the APC payment directly to the journal. Note that the payment must be made by a permanent staff member of the University of Peradeniya.  To process your reimbursement, kindly provide the following:
// o	A copy of the invoice issued by the journal.
// o	A redacted extract of the credit card statement or payment receipt (showing only the last four digits of the card number for security purposes).

// Please upload these documents as a single PDF file into the URC Research and Award Management System(https://rgms.pdn.ac.lk ->Awards -> APC Application → Upload Payment Receipt section). Reimbursement will be processed promptly upon verification of the submitted documents.
// Should you have any questions or require further assistance, please contact [secretaryurc@gs.pdn.ac.lk]. We appreciate your commitment to advancing research at the University of Peradeniya and look forward to supporting your publication.


// For any inquries please contact Secretary : secretaryurc@gs.pdn.ac.lk

// Best regards,
// Director/URC

//       `;
//       setEmailBody(defaultBody);
//     }
//     if (name) setRecipientName(name);
//     if (email) setRecipientEmail(email);
//   }, [awardType, name, email, applicationId]);

//   const handleSendEmail = async () => {
//     const updatedEmailBody = `
//  Dear ${name || "[Recipient Name]"},

// Thank you for submitting your application for Article Processing Charge (APC) reimbursement. We are pleased to confirm that your manuscript meets the eligibility criteria for APC reimbursement.

// Reimbursement Details:
// o	International Journals: If your manuscript is submitted to an international journal, you are eligible for reimbursement of up to US$1,500.
// o	Ceylon Journal of Science: If your manuscript is submitted to the Ceylon Journal of Science, you are eligible for reimbursement of up to LKR 10,000.

// Next Steps:
// Proceed with Payment: Please make the APC payment directly to the journal. Note that the payment must be made by a permanent staff member of the University of Peradeniya.  To process your reimbursement, kindly provide the following:
// o	A copy of the invoice issued by the journal.
// o	A redacted extract of the credit card statement or payment receipt (showing only the last four digits of the card number for security purposes).

// Please upload these documents as a single PDF file into the URC Research and Award Management System(https://rgms.pdn.ac.lk ->Awards -> APC Application → Upload Payment Receipt section). Reimbursement will be processed promptly upon verification of the submitted documents.
// Should you have any questions or require further assistance, please contact [secretaryurc@gs.pdn.ac.lk]. We appreciate your commitment to advancing research at the University of Peradeniya and look forward to supporting your publication.


// For any inquries please contact Secretary : secretaryurc@gs.pdn.ac.lk

// Best regards,
// Director/URC
//     `;

//     setEmailBody(updatedEmailBody);

//     try {
//       const response = await axios.post(
//         `${API_BASE_URL}/updatePaymentRequest`,
//         {
//           app_ID: applicationId,
//         }
//       );

//       if (response.status === 200) {
//         alert("Email sent and payment request updated successfully!");
//         navigate("/apc");
//       } else {
//         alert("Failed to update payment request.");
//       }
//     } catch (error) {
//       console.error("Error updating payment request:", error);
//       alert("An error occurred while updating payment request.");
//     }

//     console.log({
//       applicationId,
//       awardType,
//       recipientName,
//       recipientEmail,
//       emailSubject,
//       ccEmails,
//       updatedEmailBody,
//     });
//     alert("Email sent successfully!");
//     navigate("/apc");
//   };

//   return (
//     <div>
//       <NavigationBar />
//       <div className="container mt-4">
//         <h2 className="page-name">Send Email</h2>
//         <Form>
//           <Form.Group className="mb-3">
//             <Form.Label>Award Type</Form.Label>
//             <Form.Control type="text" value={awardType} readOnly />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Recipient Name</Form.Label>
//             <Form.Control
//               type="text"
//               value={recipientName}
//               onChange={(e) => setRecipientName(e.target.value)}
//               placeholder="Enter recipient's name"
//             />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Recipient Email</Form.Label>
//             <Form.Control
//               type="email"
//               value={recipientEmail}
//               onChange={(e) => setRecipientEmail(e.target.value)}
//               placeholder="Enter recipient's email"
//             />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>CC Emails (Bursar Email) </Form.Label>
//             <Form.Control
//               type="text"
//               value={ccEmails}
//               onChange={(e) => setCcEmails(e.target.value)}
//               placeholder="Enter CC emails (comma-separated)"
//             />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Email Subject</Form.Label>
//             <Form.Control
//               type="text"
//               value={emailSubject}
//               onChange={(e) => setEmailSubject(e.target.value)}
//             />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Email Body</Form.Label>
//             <Form.Control
//               as="textarea"
//               rows={6}
//               value={emailBody}
//               onChange={(e) => setEmailBody(e.target.value)}
//             />
//           </Form.Group>

//           <Button
//             variant="primary"
//             className="Send_Button"
//             onClick={handleSendEmail}
//           >
//             Send
//           </Button>
//         </Form>
//       </div>
//     </div>
//   );
// }
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import axios from "axios";
import NavigationBar from "../../Components/NavigationBar";

export default function SendEmailApplicant() {
  const location = useLocation();
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

  const { applicationId, awardType, name, email } = location.state || {};

  console.log("Received data:", { applicationId, awardType, name, email });

  const [recipientName, setRecipientName] = useState("");
  const [recipientEmail, setRecipientEmail] = useState("");
  const [emailSubject, setEmailSubject] = useState("");
  const [ccEmails, setCcEmails] = useState("");
  const [emailBody, setEmailBody] = useState("");

  // Set default subject and body when component loads
  useEffect(() => {
    if (awardType) {
      console.log("Setting email body with award type:", awardType);
      setEmailSubject(`Verification and Approval of – ${awardType}`);

      const defaultBody = `Dear ${name || "[Recipient Name]"},\n\nThank you for submitting your application for Article Processing Charge (APC) reimbursement. We are pleased to confirm that your manuscript meets the eligibility criteria for APC reimbursement.\n\nReimbursement Details:\no\tInternational Journals: If your manuscript is submitted to an international journal, you are eligible for reimbursement of up to US$1,500.\no\tCeylon Journal of Science: If your manuscript is submitted to the Ceylon Journal of Science, you are eligible for reimbursement of up to LKR 10,000.\n\nNext Steps:\nProceed with Payment: Please make the APC payment directly to the journal. Note that the payment must be made by a permanent staff member of the University of Peradeniya. To process your reimbursement, kindly provide the following:\no\tA copy of the invoice issued by the journal.\no\tA redacted extract of the credit card statement or payment receipt (showing only the last four digits of the card number for security purposes).\n\nPlease upload these documents as a single PDF file into the URC Research and Award Management System (https://rgms.pdn.ac.lk -> Awards -> APC Application → Upload Payment Receipt section). Reimbursement will be processed promptly upon verification of the submitted documents.\nShould you have any questions or require further assistance, please contact [secretaryurc@gs.pdn.ac.lk]. We appreciate your commitment to advancing research at the University of Peradeniya and look forward to supporting your publication.\n\nFor any inquiries please contact Secretary: secretaryurc@gs.pdn.ac.lk\n\nBest regards,\nDirector/URC`;
      setEmailBody(defaultBody);
    }
    if (name) setRecipientName(name);
    if (email) setRecipientEmail(email);
  }, [awardType, name, email, applicationId]);

  const handleSendEmail = async () => {
    if (!recipientName || !recipientEmail) {
      alert("Please fill in recipient name and email.");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(recipientEmail)) {
      alert("Please enter a valid email address.");
      return;
    }
    if (ccEmails) {
      const ccArray = ccEmails.split(',').map(email => email.trim());
      if (!ccArray.every(email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))) {
        alert("Please enter valid CC email addresses (comma-separated).");
        return;
      }
    }

    const updatedEmailBody = `Dear ${recipientName},\n\nThank you for submitting your application for Article Processing Charge (APC) reimbursement. We are pleased to confirm that your manuscript meets the eligibility criteria for APC reimbursement.\n\nReimbursement Details:\no\tInternational Journals: If your manuscript is submitted to an international journal, you are eligible for reimbursement of up to US$1,500.\no\tCeylon Journal of Science: If your manuscript is submitted to the Ceylon Journal of Science, you are eligible for reimbursement of up to LKR 10,000.\n\nNext Steps:\nProceed with Payment: Please make the APC payment directly to the journal. Note that the payment must be made by a permanent staff member of the University of Peradeniya. To process your reimbursement, kindly provide the following:\no\tA copy of the invoice issued by the journal.\no\tA redacted extract of the credit card statement or payment receipt (showing only the last four digits of the card number for security purposes).\n\nPlease upload these documents as a single PDF file into the URC Research and Award Management System (https://rgms.pdn.ac.lk -> Awards -> APC Application → Upload Payment Receipt section). Reimbursement will be processed promptly upon verification of the submitted documents.\nShould you have any questions or require further assistance, please contact [secretaryurc@gs.pdn.ac.lk]. We appreciate your commitment to advancing research at the University of Peradeniya and look forward to supporting your publication.\n\nFor any inquiries please contact Secretary: secretaryurc@gs.pdn.ac.lk\n\nBest regards,\nDirector/URC`;

    try {
      // Send email via nodemailer
      const emailResponse = await axios.post(`${API_BASE_URL}/sendEmail`, {
        to: recipientEmail,
        cc: ccEmails || null, // Include CC emails if provided
        subject: emailSubject,
        text: updatedEmailBody,
        html: `<p>${updatedEmailBody.replace(/\n/g, '<br>')}</p>`,
      });

    

      // Update payment request
      const updateResponse = await axios.post(`${API_BASE_URL}/updatePaymentRequest`, {
        app_ID: applicationId,
      });

      if (updateResponse.status === 200) {
        alert(`${emailResponse.data.message}\nPayment request updated successfully!`);
        navigate("/apc");
      } else {
        alert("Email sent, but failed to update payment request.");
      }
    } catch (error) {
      console.error("Error sending email or updating payment request:", error);
      alert("An error occurred while sending email or updating payment request.");
    }
  };

  return (
    <div>
      <NavigationBar />
      <div className="container mt-4">
        <h2 className="page-name">Send Email</h2>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Award Type</Form.Label>
            <Form.Control type="text" value={awardType || ""} readOnly />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Recipient Name</Form.Label>
            <Form.Control
              type="text"
              value={recipientName}
              onChange={(e) => setRecipientName(e.target.value)}
              placeholder="Enter recipient's name"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Recipient Email</Form.Label>
            <Form.Control
              type="email"
              value={recipientEmail}
              onChange={(e) => setRecipientEmail(e.target.value)}
              placeholder="Enter recipient's email"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>CC Emails (Bursar Email)</Form.Label>
            <Form.Control
              type="text"
              value={ccEmails}
              onChange={(e) => setCcEmails(e.target.value)}
              placeholder="Enter CC emails (comma-separated)"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email Subject</Form.Label>
            <Form.Control
              type="text"
              value={emailSubject}
              onChange={(e) => setEmailSubject(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email Body</Form.Label>
            <Form.Control
              as="textarea"
              rows={6}
              value={emailBody}
              onChange={(e) => setEmailBody(e.target.value)}
            />
          </Form.Group>

          <Button
            variant="primary"
            className="Send_Button"
            onClick={handleSendEmail}
            disabled={!applicationId || !awardType}
          >
            Send
          </Button>
        </Form>
      </div>
    </div>
  );
}